<template>
  <avs-card>
    <template v-slot:title>
      <v-card-title class="pl-0">{{ $t("commons.edit") }} {{ action.name }}</v-card-title>
    </template>
    <template v-slot:content>
      <v-container>
        <v-form
          :readonly="!isEditable"
          ref="form"
        >
          <v-text-field
            v-model="action.name"
            :rules="rules.name"
            :label="$t('commons.name')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>

          <v-text-field
            v-model="action.permission_code"
            :rules="rules.code"
            :label="$t('commons.code')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>

          <v-text-field
            v-model="action.menu_name"
            :rules="rules.name"
            :label="$t('commons.menu')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>

          <v-textarea
            v-model="action.description"
            :rules="rules.description"
            :label="$t('commons.description')"
            outlined
            dense
          ></v-textarea>

          <v-col class="d-flex justify-end gap-4">
            <avs-saveButton
              @click="save"
              :disabled="!isEditable"
            />
            <avs-cancelButton @click="cancel" />
          </v-col>
        </v-form>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
import { ActionService } from "@/services"
import { isEqual } from "@/utils/object"
import { required, slug, max64 } from "@/utils/validator"

import _ from "lodash"

export default {
  name: "ActionEditor",
  props: {
    hasUniqueName: {
      type: Function,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object
    }
  },
  computed: {
    action: {
      get() {
        return _.cloneDeep(this.value || this.getDefaultValue())
      }
    }
  },
  data() {
    return {
      rules: {
        description: [],
        code: [required, slug, max64],
        name: [required, max64]
      },
      nameField: null
    }
  },
  created() {},
  methods: {
    getDefaultValue() {
      return {
        name: "",
        description: "",
        menu_name: "",
        permission_code: ""
      }
    },
    cancel() {
      this.$emit("cancel")
    },
    async performSave(data) {
      if (data.id > 0) {
        return ActionService.put(data)
      } else {
        return ActionService.post(data)
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (isEqual(this.action, this.value)) {
          // Objects are equal, no changes to perform
          this.$emit("success")
        } else {
          this.performSave(this.action)
            .then(response => {
              this.$emit("input", response)
              this.$emit("success")
            })
            .catch(error => {
              const message = error?.response.data?.state
              this.$emit("error", message)
            })
        }
      }
    }
  }
}
</script>
